import React from 'react';
import styled from 'styled-components';
import { Sparkles } from 'lucide-react';
import { InsightCard } from './InsightCard';
import { EVENTO_ABRIR_ASSISTENTE, useInsights } from './InsightsProvider';

const QUANTIDADE_NO_DASHBOARD = 3;

const Caixa = styled.section`
  background: #fff;
  border: 1px solid #c7d4e8;
  border-radius: 14px;
  padding: 18px 20px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const Cabecalho = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Avatar = styled.div`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #1f467e;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const Titulo = styled.div`
  font-weight: 700;
  font-size: 16px;
  color: #1f2937;
`;

const Subtitulo = styled.div`
  font-size: 12px;
  color: #64748b;
`;

const VerTodos = styled.button`
  margin-left: auto;
  background: none;
  border: 0;
  color: #1f467e;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
`;

const Grade = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 700px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

/** "O assistente notou": os três insights mais importantes do dia no topo do dashboard. */
export const CardAssistenteNotou: React.FC = () => {
  const { habilitado, itens } = useInsights();
  if (!habilitado || itens.length === 0) return null;

  const destaques = itens.slice(0, QUANTIDADE_NO_DASHBOARD);
  const abrirTodos = () => window.dispatchEvent(new CustomEvent(EVENTO_ABRIR_ASSISTENTE, { detail: { aba: 'insights' } }));

  return (
    <Caixa aria-label="O assistente notou">
      <Cabecalho>
        <Avatar><Sparkles size={20} /></Avatar>
        <div>
          <Titulo>O assistente notou</Titulo>
          <Subtitulo>
            {itens.length > destaques.length
              ? `Os ${destaques.length} mais importantes de ${itens.length} para você hoje`
              : 'O mais importante para você hoje'}
          </Subtitulo>
        </div>
        {itens.length > destaques.length && (
          <VerTodos type="button" onClick={abrirTodos}>Ver todos ({itens.length})</VerTodos>
        )}
      </Cabecalho>
      <Grade>
        {destaques.map((item, i) => (
          <InsightCard key={item.id} item={item} superficie="card_dashboard" posicao={i} compacto />
        ))}
      </Grade>
    </Caixa>
  );
};
